import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { UserRole } from '@classes/licence/user-role';
import { LicenceService } from '@services/licence.service';
import { UiService } from '@services/ui.service';

@Component({
    selector: 'app-role-edit',
    templateUrl: './role-edit.component.html',
    styleUrls: ['./role-edit.component.scss']
})
export class RoleEditComponent implements OnInit, OnDestroy {
    @Input() role: UserRole;
    @Output() editFinished = new EventEmitter<void>();

    private loadingSub: Subscription;

    roleForm: FormGroup;
    rolesList: UserRole[];

    isLoading = true;

    constructor(
        private fb: FormBuilder,
        private licenceSrv: LicenceService,
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    onSubmit(): void {
        this.isLoading = true;

        if(this.role) {
            this.updateRole();
        } else {
            this.createRole();
        }
    }

    onCancel(): void {
        this.editFinished.emit();
    }

    private updateRole(): void {
        const roleCopy: UserRole = JSON.parse(JSON.stringify(this.role));
        roleCopy.userQuota.max = this.roleForm.value.maxUsers;
        this.licenceSrv.putRole(roleCopy).subscribe(() => this.isLoading = false );
    }

    private createRole(): void {
        this.role = new UserRole(
            this.rolesList.find(r => r.code === this.roleForm.value.role),
            this.roleForm.value.maxUsers);

        this.licenceSrv.postRole(this.role).subscribe(() => this.isLoading = false );
    }

    private initSubscriptions(): void {
        this.licenceSrv.getDropdownsContent()
        .subscribe(dropdownsContent => {
            const licenceRoles = this.licenceSrv.getSelectedLicence().roles;
            this.rolesList = dropdownsContent.roles
                .filter(r => r.code !== 'bizzdev')
                .filter(r => !licenceRoles.some(lr => lr.code === r.code) || (this.role && this.role.code === r.code));

            this.initForm();
            this.isLoading = false;
        });

        this.loadingSub = this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
            this.isLoading = loadingState;
        });
    }

    private initForm(): void {
        let role = "";
        let maxUsers = 1;

        if (this.role) {
            role = this.role.code;
            maxUsers = this.role.userQuota ? this.role.userQuota.max : 1;
        }

        const maxUsersValidator = !this.role
            ? [Validators.required, Validators.min(1)]
            : [Validators.required, Validators.min(1), Validators.min(this.role.userQuota.value)];

        this.roleForm = this.fb.group({
            role: [{value: role, disabled: !!this.role}, Validators.required],
            maxUsers: [maxUsers, maxUsersValidator]
        });
    }

    ngOnDestroy(): void {
        if(this.loadingSub) {
            this.loadingSub.unsubscribe();
        }
    }
}
